import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { LabelingComponentComponent } from './labeling-component/labeling-component.component';

@NgModule({
  declarations: [AppComponent, LabelingComponentComponent],
  imports: [BrowserModule],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
